import React from "react";
import { Outlet } from "react-router";
import { PageShell } from "@sscs/ui";
import Navigation from "../../components/Navigation/Navigation";
import styles from "./softwareCatalog.module.scss";

const SoftwareCatalog = (): React.JSX.Element => {
  return (
    <PageShell sidebar={<Navigation />} contentClassName={styles.content}>
      <Outlet />
    </PageShell>
  );
};

export default SoftwareCatalog;
